import { ReduxStore } from 'store/types';

function importSpreadsheetIsLoading(state: ReduxStore): boolean {
  return state.product.importSpreadsheet.config.isLoading;
}

export default importSpreadsheetIsLoading;
